import React, { useState } from "react";
import { Drawer } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LogoutIcon from "@mui/icons-material/Logout";
import newLogo from "../../pages/smart-lend-frontend/src/img/sl_long_new_logo_wo_beta.png";

export default function LenderMobileNavigation({
  canManageCases, canManageManualLoans, isLoggingOut, onLogout, onOpenNotifications,
}) {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  return (
        <>
          <button
            type="button"
            className="sl-mobile-menu-button"
            aria-label="Open lender navigation"
            aria-expanded={menuIsOpen}
            onClick={() => setMenuIsOpen(true)}
          >
            <MenuOutlined />
          </button>
          <Drawer
            title={<img src={newLogo} alt="Smart-Lend" className="sl-mobile-menu-logo" />}
            placement="left"
            width="min(340px, 90vw)"
            open={menuIsOpen}
            onClose={() => setMenuIsOpen(false)}
            rootClassName="sl-lender-mobile-drawer"
          >
            <nav aria-label="Lender navigation" className="sl-mobile-nav">
              {[
                ["/dashboard", "Dashboard"],
                ["/l-messages", "Messages"],
                ["/loan-request-grid", "Loan Requests"],
                ["/pending-acceptance", "Pending Acceptance"],
                ["/accepted-loans", "Accepted Loans"],
                ["/l-payments", "Payments"],
                ["/analytics", "Analytics"],
                ["/l-profile", "My Profile"],
                ["/l-document-builder", "Doc Builder"],
                ["/l-bank-statement-portal", "Bank Statement Portal"],
                ...(canManageCases ? [["/l-manage-cases", "Manage Cases"]] : []),
                ...(canManageManualLoans
                  ? [["/l-manual-giro", "Manual Loans"]] : []),
              ].map(([to, label]) => (
                <NavLink key={to} to={to} activeClassName="is-active"
                  onClick={() => { setMenuIsOpen(false); window.scrollTo(0, 0); }}>
                  <span>{label}</span><NavigateNextIcon />
                </NavLink>
              ))}
              <button type="button" onClick={() => {
                setMenuIsOpen(false);
                onOpenNotifications();
              }}>Notification Settings</button>
              <button type="button" disabled={isLoggingOut} onClick={onLogout}>
                Log Out <LogoutIcon />
              </button>
            </nav>
          </Drawer>
        </>
  );
}
